'use client';
import { getDefaultZIndex } from '@s7/styles';

const IDENT_MODAL = 'Modal';
const defaultProps = {
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: getDefaultZIndex('modal'),
    padding: '4s'
};

export { IDENT_MODAL, defaultProps };
//# sourceMappingURL=Modal.contract.js.map
